import { EditResBskComponent } from './edit-resbsk/edit-resbsk.component';
import { AddResBskComponent } from './add-resbsk/add-resbsk.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListResBskComponent } from './list-resbsk/list-resbsk.component';

export const routesResBsk: Routes = [
    { path: 'page-resbsk', component: ListResBskComponent},
    { path: 'page-resbsk/add', component: AddResBskComponent},
    { path: 'page-resbsk/:id/edit', component: EditResBskComponent}
];

export const ResBskRoutes: ModuleWithProviders = RouterModule.forChild(routesResBsk);
